import React from 'react'
import { useNavigate } from 'react-router-dom'

import './Dashboard.css'
import DashCard from './DashCard'

const adminRoutes = [
    {
        title: 'Facility',
        route: 'facility'
    },
    {
        title: 'Achievements',
        route: 'achievements'
    },
    {
        title: 'Announcements',
        route: 'announcements'
    },
    {
        title: 'Syllabus',
        route: 'syllabus'
    },
    {
        title: 'Toppers',
        route: 'toppers'
    },
    {
        title: 'Testimonials',
        route: 'testimonials'
    },
    {
        title: 'Project',
        route: 'project'
    },
    {
        title: 'Gallery',
        route: 'gallery'
    },
    {
        title: 'Placement Carousel',
        route: 'placement-carousel'
    },
    {
        title: 'Landing Carousel',
        route: 'landing-carousel'
    },
    {
        title: 'Faculty',
        route: 'faculty'
    },
    {
        title: 'Reset Faculty Password',
        route: 'faculty/reset-password'
    },
    {
        title: 'Clubs',
        route: 'clubs'
    },
    {
        title: 'Reset Club Password',
        route: 'clubs/reset-password'
    }
]

function Dashboard() {
    const navigate = useNavigate()
    const logout = () => {
        const authToken = localStorage.getItem('token')
        if (!authToken) {
            alert("not logged in")
        } else {
            localStorage.removeItem('token')
            alert("Logged out")
            navigate('/admin-login')
        }
    }

    return (
        <div className='admin'>
            <div className='section__container'>
                <div className='section'>
                    <div>
                        <button className='admin_btn' onClick={logout} >Logout</button>
                    </div>
                    <h1 className='section__header'>Dashboard</h1>
                    <div className='dashboard__container'>
                        {adminRoutes.map((adm, id) => (
                            <DashCard
                                key={id}
                                id={id}
                                title={adm.title}
                                route={adm.route}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Dashboard